import React, { Component, createElement } from "react";
import { connect } from "react-redux";
import ExpansiveTicket from "../../../../shared/ExpansiveTicket/ExpansiveTicket";
import Checkbox from "../../../../shared/Checkbox/Checkbox";
import Button from "../../../../shared/button/button";
import {
	setStep,
	onCancelRelationship,
	setDataToStoreDocuments
} from "../../../actions/advanced-management";
import { bindActionCreators } from "redux";
import { dateToHHMM } from "../../../../../js/shared/utils";
import { formatDateToLocalDate, isRelationshipStatusInactive } from "../../../shared/utils";
import Loading from "../../../../shared/Loading/Loading";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

class AdvancedManagementPartakers extends Component {
	constructor() {
		super();
		this.state = {
			term: false
		};
	}

	renderCheckbox() {
		return (
			<Checkbox
				id="term"
				name="term"
				onChange={options => this.setState({ term: options[0].checked })}
				options={[
					{
						label: (
							<span>
								Li e estou de acordo com as{" "}
								<a className="term-link" onClick={() => {
									this.props.onRenderModalTerms()
									publish(eventType.ACCOUNT_FAMILY, {
										type: ACCOUNT_FAMILY_EVENT.button_rule
									})
								}}>
									<strong>regras de utilização</strong>
								</a>{" "}
								da Conta Família.
							</span>
						),
						name: "term",
						checked: this.state.term
					}
				]}
			/>
		);
	}

	mountTimelineItems = data => {
		let dataStepInfo = this.getInfoStep(data);
		let timeLine = [
			{
				label: "<strong>Indicação<br />enviada</strong>",
				description: this.formatTimelineItemDescription(
					data.invited,
					data.canceled,
					this.setTimelineItemActiveStatus(data, 0)
				),
				active: dataStepInfo.step > 0
			},
			{
				label: "<strong>Solicitação<br />de vínculo</strong>",
				description: this.formatTimelineItemDescription(
					data.invited && !data.bond && data.canceled ? data.updated : data.bond,
					this.setTimelineItemActiveStatus(data, 1)
				),
				active: this.setTimelineItemActiveStatus(data, 1)
			},
			{
				label: "<strong>Confirmação<br />do gestor</strong>",
				description: this.formatTimelineItemDescription(
					data.bond && !data.sent && data.canceled ? data.updated : data.sent,
					this.setTimelineItemActiveStatus(data, 2)
				),
				active: this.setTimelineItemActiveStatus(data, 2)
			},
			{
				label: "<strong>Em análise na<br />MaxMilhas</strong>",
				description: this.formatTimelineItemDescription(
					data.sent && !data.evaluated && data.canceled ? data.updated : data.evaluated
				),
				active: this.setTimelineItemActiveStatus(data, 3)
			},
			{
				label: "<strong>Vínculo<br />ativado</strong>",
				description: this.formatTimelineItemDescription(data.evaluated),
				active: data.evaluated
			}
		];
		data.canceled && data.evaluated ? (
			timeLine = [
				...timeLine,
				{
					label: "<strong>Conta<br />desvinculada</strong>",
					description: this.formatTimelineItemDescription(
						data.canceled,
						data.canceled,
						this.setTimelineItemActiveStatus(data, 4)
					),
					active: data.canceled
				}
			]
		) : true
		return {
			activeColor: "success",
			inactiveColor: "danger",
			activeIcon: "check",
			inactiveIcon: "close",
			lengthMax: timeLine.length === 6,
			parent: {
				className: dataStepInfo.className,
				statusTitle: dataStepInfo.statusTitle,
				currentStep: dataStepInfo.step
			},
			data: timeLine
		};
	};

	formatTimelineItemDescription = (date, cancelationDate, isCanceled) => {
		if (!date) {
			return "";
		}

		date = isCanceled === false ? cancelationDate : date;

		return `${formatDateToLocalDate(date)} <br /> ${dateToHHMM(date)}`;
	};

	setTimelineItemActiveStatus = (data, step) =>
		this.getInfoStep(data).step > step
			? true
			: this.getInfoStep(data).step === step && this.getInfoStep(data).canceled ? false : null;

	getInfoStep = data => {
		switch (data.status.status) {
			case "N":
				return {
					className: "primary",
					statusTitle: "Em negociação",
					step: data.status.subStatus === "inviteSendParticipant" ? 1 : 2
				};
			case "P":
				return {
					className: "warning",
					statusTitle: "Em análise",
					step: 3
				};
			case "A":
				return {
					className: "success",
					statusTitle: "Ativo",
					step: 4
				};
			case "I":
				return {
					className: "",
					statusTitle: "Inativo",
					step: this.calcStepCancelation(data),
					canceled: true
				};
			default:
				return "";
		}
	};

	calcStepCancelation = data => {
		if (!data.bond && data.invited && data.canceled) {
			return 1;
		} else if (!data.bond) {
			return 0;
		} else if (!data.sent && data.bond && data.canceled) {
			return 2;
		} else if (!data.sent) {
			return 1;
		} else if (data.sent && !data.evaluated && data.canceled) {
			return 3;
		} else if (!data.evaluated) {
			return 2;
		}
	};

	saveDocuments = data => {
		this.props.setDataToStoreDocuments({
			relationId: data._id,
			idManager: data.idManager,
			idParticipant: data.idParticipant
		});
		this.props.setStep(3);
	};

	render() {
		const { setStep, onDisapprove, onCancel, data, isLoading } = this.props;

		const buttonStart = createElement(
			Button,
			{
				className: "btn-secondary-sm",
				onClick: () => this.saveDocuments(data)
			},
			<span>Aprovar</span>
		);

		return (
			<ExpansiveTicket
				timelineConfig={this.mountTimelineItems(data)}
				description={data.status.name}
				partner={data.participant.name}
			>
				<div className="advanced-management-partakers">
					<div className="advanced-management-partakers__line">
						<div className="advanced-management-partakers__line--left">
							<div className="advanced-management-partakers__line--item">
								<div>CPF</div>
								<strong>{data.participant.ssn}</strong>
							</div>
							<div className="advanced-management-partakers__line--item">
								<div>Cidade</div>
								<strong>{data.participant.city}</strong>
							</div>
						</div>
						<div className="advanced-management-partakers__line--approve">
							{!isRelationshipStatusInactive(data) &&
								data.status.subStatus !== "waitingApprovalManager" && (
									<Button onClick={() => onCancel(data)} className="btn btn-gray-md-icon rounded gray">
										<i className="icon-trash" />
									</Button>
								)}
							{data.status.subStatus === "waitingApprovalManager" && (
								<div className="advanced-management-partakers__line--item flex-row">
									<Button className="btn-gray-sm-label" onClick={() => onDisapprove(data)}>
										Reprovar
									</Button>
									{buttonStart}
								</div>
							)}
						</div>
					</div>
				</div>
			</ExpansiveTicket>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStep,
			onCancelRelationship,
			setDataToStoreDocuments
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedManagementPartakers);
